import React from 'react'
import Navbar from '../../components/Navbar'
import DeveloperCard from '../../components/DeveloperCard'
import DevPortfolio from '../../components/DevPortfolio'

const Developer = () => {
    return(
      <>
       <DeveloperCard />
       <DevPortfolio />
      </>
    )
  }
  
  export default Developer